<template>
	<div
		:class="['assessment-card-skeleton', customClass]"
		:style="containerStyle"
	>
		<div class="d-flex align-items-start">
			<b-skeleton
				type="avatar"
				:width="isMobile ? '40px' : '50px'"
				:height="isMobile ? '40px' : '50px'"
				class="mr-3"
			/>

			<div class="flex-grow-1">
				<b-skeleton
					:width="isMobile ? '80%' : '70%'"
					height="18px"
					class="mb-2"
				/>
				<b-skeleton
					:width="isMobile ? '60%' : '40%'"
					height="14px"
					class="mb-3"
				/>

				<div class="d-flex justify-content-between">
					<b-skeleton :width="isMobile ? '60px' : '80px'" height="14px" />

					<div class="d-flex gap-2">
						<b-skeleton :width="isMobile ? '50px' : '60px'" height="14px" />
						<b-skeleton :width="isMobile ? '50px' : '60px'" height="14px" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AssessmentCardSkeleton",
	props: {
		isMobile: {
			type: Boolean,
			default: false,
		},
		customClass: {
			type: String,
			default: "",
		},
		customStyle: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		containerStyle() {
			return {
				...this.customStyle,
			};
		},
	},
};
</script>

<style scoped>
.assessment-card-skeleton {
	height: 140px;
}

@media (max-width: 1028px) {
	.assessment-card-skeleton {
		height: 110px;
	}
}
</style>
